import { render } from "./NotifyMain.vue?vue&type=template&id=3af4ad8f"
import script from "./NotifyMain.vue?vue&type=script&lang=js"
export * from "./NotifyMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__